import { useContext, useEffect, useState } from "react";
import {
  getVersions,
  createVersions,
  updateVersions,
  deleteVersion,
} from "../services/console/version";
import { AppContext } from "../context";
import { Version } from "../interfaces";

type UseType = "DATA" | "ACTIONS";
type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleVersionActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createVersions,
        fnMsg: t("Versions.apiCreateLabel"),
        actionType: action,
      };
    case "UPDATE":
      return {
        actionFn: updateVersions,
        fnMsg: t("Versions.apiUpdateLabel"),
        actionType: action,
      };
    case "DELETE":
      return {
        actionFn: deleteVersion,
        fnMsg: t("Versions.apiDeleteLabel"),
        actionType: action,
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
        actionType: "",
      };
  }
};

export const useVersions = (type: UseType, filterActiveRecords = true) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);
  const appid = selectedApp?.appid || "0";

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const versionAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleVersionActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    let toastData: {} | null = null;
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((_) => {
        toastData = {
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        };
        toast.current.replace(toastData);
        return "SUCCESS";
      })
      .catch((error) => {
        toastData = {
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        };
        // if (actionType !== "UPDATE") {
        //   toast.current.replace(toastData);
        // }
        toast.current.replace(toastData);
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
      toastData,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA" && appid) {
      (async function () {
        await Promise.resolve(getVersions())
          .then((response) => {
            const data = filterActiveRecords
              ? response?.data.filter(
                  (version: Version) => version.status === "ACTIVE"
                )
              : response?.data;
            setData(data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [appid, toast, reload, type, filterActiveRecords]);

  return {
    data,
    versionAction,
    reloadFn,
  };
};
